/**
 * @class
 * @override
 */
import Base from 'netxcore@netx/core-app/views/appModalCrumbsView';

import {MDCTabBar} from '@material/tab-bar';

export default class AppModalCrumbsView extends Base {
	/** @override */
	constructor(opts = {}) {
		super(opts);

		// Debounced/throttled methods
		this.resize = _.debounce(this.resize, 32);
	}

	/** @override */
	bindCollectionEvents() {
		super.bindCollectionEvents();

		return this.listenTo(this.collection, 'change:active', (tab, active) => {
			if (!active) return;
			this.checkMaterialTabActive();
		});
	}

	/** @method */
	checkMaterialTabActive() {
		if (!this.tabBar) return;

		const active = this.collection.findWhere({active: true});
		if (!active) return;

		const name = active.get('name');
		const idx = this.tabBar.tabList_.findIndex((tab) => {
			return tab.root_.getAttribute('data-nx-tab-name') === name;
		});
		if (idx > -1) {
			this.tabBar.activateTab(idx);
		}
	}

	/** @override */
	preRender() {
		if (this.tabBar) {
			this.tabBar.destroy();
			delete this.tabBar;
		}

		super.preRender();
	}

	/** @override */
	postRender() {
		super.postRender();

		this.setupMaterial();
	}

	/** @method */
	resize() {
		const tabBar = this.tabBar;
		if (!tabBar) return;

		// Overflow
		const tabScroller = tabBar.tabScroller_;
		if (tabScroller) {
			const tabScrollerEl = tabScroller.root_;
			tabScrollerEl.classList.toggle(
				'mdc-tab-scroller--overflown',
				tabScroller.getScrollContentWidth() > tabScrollerEl.offsetWidth,
			);
		}

		// Bring tab into view
		const idx = tabBar.foundation_.adapter_.getPreviousActiveTabIndex();
		idx > -1 && tabBar.scrollIntoView(idx);
	}

	/** @method */
	setupMaterial() {
		if (this.tabBar) {
			this.tabBar.destroy();
			delete this.tabBar;
		}

		const el = this.el.querySelector('.mdc-tab-bar');
		if (!el) return;

		const tabBar = (this.tabBar = new MDCTabBar(el));
		return tabBar;
	}

	/** @override */
	crumbsChanged() {
		super.crumbsChanged();

		// Destroy and reinit resize listener when recreating material tabs
		this.Plugins.Destroy('resizeListener', this.$el);

		this.setupMaterial();
		this.checkMaterialTabActive();

		this.Plugins.Initialize('resizeListener', this.$el);
	}
}
